import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { StaffMemberUpload } from '../../../models/StaffMemberUpload';

@Component({
  selector: 'app-staff-table',
  templateUrl: './staff-table.component.html',
  styleUrls: ['./staff-table.component.scss']
})
export class StaffTableComponent implements OnInit {

  @Input() dataSource: MatTableDataSource<StaffMemberUpload>;
  @Output() isValidState: EventEmitter<boolean> = new EventEmitter;
  constructor() { }

  ngOnInit(): void {
    this.isValidState.emit(!!this.dataSource)
  }

}
